const normalizePhone = (value) => {
	if (!value) return value
	if (value.length === 1) {
		return `+7${value.replace(/[^\d]/g, '')}`
	}
	if (value === '+7') {
		return null
	}
	const onlyNums = value.replace(/[^\d]/g, '')
	return `+${onlyNums}`
}

const normalizePassport = (value, previousValue) => {
	if (previousValue && value.length <= previousValue.length) return value
	if (/^\d{1,4} \d{1,6}$/.test(value)) return value
	if (value.length > 11) {
		return previousValue
	}
	let onlyNums = value.replace(/[^\d]/g, '')
	if (onlyNums.length > 4) onlyNums = `${onlyNums.substring(0, 4)} ${onlyNums.substring(4)}`
	return onlyNums
}

const normalizeOkpo = (value) => {
	return value.replace(/[^\d]/g, '')
}

const handleChangeQuotes = (value) => {
	return value.replace(/«/g, '"').replace(/»/g, '"').replace(/""/g, '"')
}

const handleChangeRc = (value) => {
	return value.replace(/[^+\d]/g, '')
}

const normalizeLinkSpaces = (value) => {
	return value.replace(/ /g, '').trim()
}

export {
	normalizeOkpo,
	normalizePhone,
	normalizePassport,
	handleChangeQuotes,
	handleChangeRc,
	normalizeLinkSpaces,
}
